interface ICellData {
    percent: boolean;
    ocr?: boolean;
    value: number;
}

export const rawData: {
    [x: string]: {
        [x: string]: Array<{ date: string; ['2022']: ICellData; ['Dev. 22/21']: ICellData; ['Dev. 22/19']: ICellData }>;
    };
} = {
    Henderson: {
        traffic: [
            {
                date: '2022-01-01',
                '2022': { ocr: true, percent: false, value: 4791 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: -10 },
            },
            {
                date: '2022-02-01',
                '2022': { percent: false, value: 4317 },
                'Dev. 22/21': { percent: true, value: 2 },
                'Dev. 22/19': { percent: true, value: -20 },
            },
            {
                date: '2022-03-01',
                '2022': { percent: false, value: 4553 },
                'Dev. 22/21': { percent: true, value: 13 },
                'Dev. 22/19': { percent: true, value: 14 },
            },
            {
                date: '2022-04-01',
                '2022': { percent: false, value: 4635 },
                'Dev. 22/21': { percent: true, value: 19 },
                'Dev. 22/19': { percent: true, value: 27 },
            },
            {
                date: '2022-05-01',
                '2022': { percent: false, value: 4442 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: 24 },
            },
            {
                date: '2022-06-01',
                '2022': { percent: false, value: 4789 },
                'Dev. 22/21': { percent: true, value: 34 },
                'Dev. 22/19': { percent: true, value: 7 },
            },
            {
                date: '2022-07-01',
                '2022': { percent: false, value: 4911 },
                'Dev. 22/21': { percent: true, value: 29 },
                'Dev. 22/19': { percent: true, value: 9 },
            },
        ],
        sales_no_vat: [
            {
                date: '2022-01-01',
                '2022': { percent: false, value: 5790907 },
                'Dev. 22/21': { percent: true, value: -1 },
                'Dev. 22/19': { percent: true, value: -19 },
            },
            {
                date: '2022-02-01',
                '2022': { percent: false, value: 5207307 },
                'Dev. 22/21': { percent: true, value: -20 },
                'Dev. 22/19': { percent: true, value: -12 },
            },
            {
                date: '2022-03-01',
                '2022': { percent: false, value: 6950001 },
                'Dev. 22/21': { percent: true, value: 17 },
                'Dev. 22/19': { percent: true, value: -3 },
            },
            {
                date: '2022-04-01',
                '2022': { percent: false, value: 7190764 },
                'Dev. 22/21': { percent: true, value: -2 },
                'Dev. 22/19': { percent: true, value: -15 },
            },
            {
                date: '2022-05-01',
                '2022': { percent: false, value: 8958215 },
                'Dev. 22/21': { percent: true, value: -1 },
                'Dev. 22/19': { percent: true, value: -15 },
            },
            {
                date: '2022-06-01',
                '2022': { percent: false, value: 8342704 },
                'Dev. 22/21': { percent: true, value: 52 },
                'Dev. 22/19': { percent: true, value: -10 },
            },
            {
                date: '2022-07-01',
                '2022': { percent: false, value: 6780632 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: -8 },
            },
        ],
        sales_per_area_no_vat: [
            {
                date: '2022-01-01',
                '2022': { percent: false, value: 28248 },
                'Dev. 22/21': { percent: true, value: -1 },
                'Dev. 22/19': { percent: true, value: -19 },
            },
            {
                date: '2022-02-01',
                '2022': { percent: false, value: 25401 },
                'Dev. 22/21': { percent: true, value: -20 },
                'Dev. 22/19': { percent: true, value: -12 },
            },
            {
                date: '2022-03-01',
                '2022': { percent: false, value: 33902 },
                'Dev. 22/21': { percent: true, value: 17 },
                'Dev. 22/19': { percent: true, value: -3 },
            },
            {
                date: '2022-04-01',
                '2022': { percent: false, value: 35077 },
                'Dev. 22/21': { percent: true, value: -2 },
                'Dev. 22/19': { percent: true, value: -15 },
            },
            {
                date: '2022-05-01',
                '2022': { percent: false, value: 43699 },
                'Dev. 22/21': { percent: true, value: -1 },
                'Dev. 22/19': { percent: true, value: -15 },
            },
            {
                date: '2022-06-01',
                '2022': { percent: false, value: 40696 },
                'Dev. 22/21': { percent: true, value: 52 },
                'Dev. 22/19': { percent: true, value: -10 },
            },
            {
                date: '2022-07-01',
                '2022': { percent: false, value: 33076 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: -8 },
            },
        ],
        sales_per_area_uniq_no_vat: [
            {
                date: '2022-01-01',
                '2022': { percent: false, value: 27036 },
                'Dev. 22/21': { percent: true, value: -8 },
                'Dev. 22/19': { percent: true, value: -23 },
            },
            {
                date: '2022-02-01',
                '2022': { percent: false, value: 21102 },
                'Dev. 22/21': { percent: true, value: -4 },
                'Dev. 22/19': { percent: true, value: -4 },
            },
            {
                date: '2022-03-01',
                '2022': { percent: false, value: 29358 },
                'Dev. 22/21': { percent: true, value: 2 },
                'Dev. 22/19': { percent: true, value: -13 },
            },
            {
                date: '2022-04-01',
                '2022': { percent: false, value: 33564 },
                'Dev. 22/21': { percent: true, value: 6 },
                'Dev. 22/19': { percent: true, value: -8 },
            },
            {
                date: '2022-05-01',
                '2022': { percent: false, value: 32440 },
                'Dev. 22/21': { percent: true, value: 5 },
                'Dev. 22/19': { percent: true, value: -8 },
            },
            {
                date: '2022-06-01',
                '2022': { percent: false, value: 30725 },
                'Dev. 22/21': { percent: true, value: 5 },
                'Dev. 22/19': { percent: true, value: -16 },
            },
            {
                date: '2022-07-01',
                '2022': { percent: false, value: 23245 },
                'Dev. 22/21': { percent: true, value: -1 },
                'Dev. 22/19': { percent: true, value: -34 },
            },
        ],
        profit: [
            {
                date: '2022-01-01',
                '2022': { percent: false, value: 1573000 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: 21 },
            },
            {
                date: '2022-02-01',
                '2022': { percent: false, value: 1573000 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: 21 },
            },
            {
                date: '2022-03-01',
                '2022': { percent: false, value: 1573000 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: 21 },
            },
            {
                date: '2022-04-01',
                '2022': { percent: false, value: 1573000 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: 21 },
            },
            {
                date: '2022-05-01',
                '2022': { percent: false, value: 1730300 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: 21 },
            },
            {
                date: '2022-06-01',
                '2022': { percent: false, value: 1730300 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: 21 },
            },
            {
                date: '2022-07-01',
                '2022': { percent: false, value: 1730300 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: 21 },
            },
        ],
        ocr: [
            {
                date: '2022-01-01',
                '2022': { ocr: true, percent: true, value: 27 },
                'Dev. 22/21': { ocr: true, percent: true, value: 3 },
                'Dev. 22/19': { ocr: true, percent: true, value: 9 },
            },
            {
                date: '2022-02-01',
                '2022': { ocr: true, percent: true, value: 30 },
                'Dev. 22/21': { ocr: true, percent: true, value: 8 },
                'Dev. 22/19': { ocr: true, percent: true, value: 8 },
            },
            {
                date: '2022-03-01',
                '2022': { ocr: true, percent: true, value: 23 },
                'Dev. 22/21': { ocr: true, percent: true, value: -2 },
                'Dev. 22/19': { ocr: true, percent: true, value: 4 },
            },
            {
                date: '2022-04-01',
                '2022': { ocr: true, percent: true, value: 22 },
                'Dev. 22/21': { ocr: true, percent: true, value: 2 },
                'Dev. 22/19': { ocr: true, percent: true, value: 7 },
            },
            {
                date: '2022-05-01',
                '2022': { ocr: true, percent: true, value: 19 },
                'Dev. 22/21': { ocr: true, percent: true, value: 2 },
                'Dev. 22/19': { ocr: true, percent: true, value: 6 },
            },
            {
                date: '2022-06-01',
                '2022': { ocr: true, percent: true, value: 21 },
                'Dev. 22/21': { ocr: true, percent: true, value: -8 },
                'Dev. 22/19': { ocr: true, percent: true, value: 5 },
            },
            {
                date: '2022-07-01',
                '2022': { ocr: true, percent: true, value: 26 },
                'Dev. 22/21': { ocr: true, percent: true, value: 0 },
                'Dev. 22/19': { ocr: true, percent: true, value: 6 },
            },
        ],
    },
    'Burger King': {
        traffic: [
            {
                date: '2022-01-01',
                '2022': { percent: false, value: 37738 },
                'Dev. 22/21': { percent: true, value: 8 },
                'Dev. 22/19': { percent: true, value: -10 },
            },
            {
                date: '2022-02-01',
                '2022': { percent: false, value: 34004 },
                'Dev. 22/21': { percent: true, value: 1 },
                'Dev. 22/19': { percent: true, value: -20 },
            },
            {
                date: '2022-03-01',
                '2022': { percent: false, value: 45530 },
                'Dev. 22/21': { percent: true, value: 42 },
                'Dev. 22/19': { percent: true, value: 45 },
            },
            {
                date: '2022-04-01',
                '2022': { percent: false, value: 46350 },
                'Dev. 22/21': { percent: true, value: 49 },
                'Dev. 22/19': { percent: true, value: -2 },
            },
            {
                date: '2022-05-01',
                '2022': { percent: false, value: 44420 },
                'Dev. 22/21': { percent: true, value: 38 },
                'Dev. 22/19': { percent: true, value: -4 },
            },
            {
                date: '2022-06-01',
                '2022': { percent: false, value: 47890 },
                'Dev. 22/21': { percent: true, value: 67 },
                'Dev. 22/19': { percent: true, value: -18 },
            },
            {
                date: '2022-07-01',
                '2022': { percent: false, value: 49110 },
                'Dev. 22/21': { percent: true, value: 61 },
                'Dev. 22/19': { percent: true, value: -16 },
            },
        ],
        sales_no_vat: [
            {
                date: '2022-01-01',
                '2022': { percent: false, value: 7319166 },
                'Dev. 22/21': { percent: true, value: 22 },
                'Dev. 22/19': { percent: true, value: -19 },
            },
            {
                date: '2022-02-01',
                '2022': { percent: false, value: 6570176 },
                'Dev. 22/21': { percent: true, value: 26 },
                'Dev. 22/19': { percent: true, value: -12 },
            },
            {
                date: '2022-03-01',
                '2022': { percent: false, value: 11978446 },
                'Dev. 22/21': { percent: true, value: 51 },
                'Dev. 22/19': { percent: true, value: -3 },
            },
            {
                date: '2022-04-01',
                '2022': { percent: false, value: 14181240 },
                'Dev. 22/21': { percent: true, value: 44 },
                'Dev. 22/19': { percent: true, value: -15 },
            },
            {
                date: '2022-05-01',
                '2022': { percent: false, value: 15984606 },
                'Dev. 22/21': { percent: true, value: 40 },
                'Dev. 22/19': { percent: true, value: -15 },
            },
            {
                date: '2022-06-01',
                '2022': { percent: false, value: 14594880 },
                'Dev. 22/21': { percent: true, value: 33 },
                'Dev. 22/19': { percent: true, value: -10 },
            },
            {
                date: '2022-07-01',
                '2022': { percent: false, value: 13112069 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: -8 },
            },
        ],
        sales_per_area_no_vat: [
            {
                date: '2022-01-01',
                '2022': { percent: false, value: 29277 },
                'Dev. 22/21': { percent: true, value: 22 },
                'Dev. 22/19': { percent: true, value: -19 },
            },
            {
                date: '2022-02-01',
                '2022': { percent: false, value: 26281 },
                'Dev. 22/21': { percent: true, value: 26 },
                'Dev. 22/19': { percent: true, value: -12 },
            },
            {
                date: '2022-03-01',
                '2022': { percent: false, value: 47914 },
                'Dev. 22/21': { percent: true, value: 51 },
                'Dev. 22/19': { percent: true, value: -3 },
            },
            {
                date: '2022-04-01',
                '2022': { percent: false, value: 56725 },
                'Dev. 22/21': { percent: true, value: 44 },
                'Dev. 22/19': { percent: true, value: -15 },
            },
            {
                date: '2022-05-01',
                '2022': { percent: false, value: 63938 },
                'Dev. 22/21': { percent: true, value: 40 },
                'Dev. 22/19': { percent: true, value: -15 },
            },
            {
                date: '2022-06-01',
                '2022': { percent: false, value: 58380 },
                'Dev. 22/21': { percent: true, value: 33 },
                'Dev. 22/19': { percent: true, value: -10 },
            },
            {
                date: '2022-07-01',
                '2022': { percent: false, value: 52448 },
                'Dev. 22/21': { percent: true, value: 10 },
                'Dev. 22/19': { percent: true, value: -8 },
            },
        ],
        sales_per_area_uniq_no_vat: [
            {
                date: '2022-01-01',
                '2022': { percent: false, value: 33924 },
                'Dev. 22/21': { percent: true, value: 11 },
                'Dev. 22/19': { percent: true, value: -20 },
            },
            {
                date: '2022-02-01',
                '2022': { percent: false, value: 37156 },
                'Dev. 22/21': { percent: true, value: -13 },
                'Dev. 22/19': { percent: true, value: -9 },
            },
            {
                date: '2022-03-01',
                '2022': { percent: false, value: 46031 },
                'Dev. 22/21': { percent: true, value: 19 },
                'Dev. 22/19': { percent: true, value: -4 },
            },
            {
                date: '2022-04-01',
                '2022': { percent: false, value: 45290 },
                'Dev. 22/21': { percent: true, value: 37 },
                'Dev. 22/19': { percent: true, value: -9 },
            },
            {
                date: '2022-05-01',
                '2022': { percent: false, value: 44854 },
                'Dev. 22/21': { percent: true, value: 21 },
                'Dev. 22/19': { percent: true, value: 1 },
            },
            {
                date: '2022-06-01',
                '2022': { percent: false, value: 43538 },
                'Dev. 22/21': { percent: true, value: 18 },
                'Dev. 22/19': { percent: true, value: -14 },
            },
            {
                date: '2022-07-01',
                '2022': { percent: false, value: 43614 },
                'Dev. 22/21': { percent: true, value: 11 },
                'Dev. 22/19': { percent: true, value: -20 },
            },
        ],
        profit: [
            {
                date: '2022-01-01',
                '2022': { percent: false, value: 1454750 },
                'Dev. 22/21': { percent: true, value: 15 },
                'Dev. 22/19': { percent: true, value: 32 },
            },
            {
                date: '2022-02-01',
                '2022': { percent: false, value: 1454750 },
                'Dev. 22/21': { percent: true, value: 15 },
                'Dev. 22/19': { percent: true, value: 32 },
            },
            {
                date: '2022-03-01',
                '2022': { percent: false, value: 1672963 },
                'Dev. 22/21': { percent: true, value: 15 },
                'Dev. 22/19': { percent: true, value: 32 },
            },
            {
                date: '2022-04-01',
                '2022': { percent: false, value: 1672963 },
                'Dev. 22/21': { percent: true, value: 15 },
                'Dev. 22/19': { percent: true, value: 32 },
            },
            {
                date: '2022-05-01',
                '2022': { percent: false, value: 1672963 },
                'Dev. 22/21': { percent: true, value: 15 },
                'Dev. 22/19': { percent: true, value: 32 },
            },
            {
                date: '2022-06-01',
                '2022': { percent: false, value: 1672963 },
                'Dev. 22/21': { percent: true, value: 15 },
                'Dev. 22/19': { percent: true, value: 32 },
            },
            {
                date: '2022-07-01',
                '2022': { percent: false, value: 1672963 },
                'Dev. 22/21': { percent: true, value: 15 },
                'Dev. 22/19': { percent: true, value: 32 },
            },
        ],
        ocr: [
            {
                date: '2022-01-01',
                '2022': { ocr: true, percent: true, value: 20 },
                'Dev. 22/21': { ocr: true, percent: true, value: -1 },
                'Dev. 22/19': { ocr: true, percent: true, value: 8 },
            },
            {
                date: '2022-02-01',
                '2022': { ocr: true, percent: true, value: 22 },
                'Dev. 22/21': { ocr: true, percent: true, value: -2 },
                'Dev. 22/19': { ocr: true, percent: true, value: 7 },
            },
            {
                date: '2022-03-01',
                '2022': { ocr: true, percent: true, value: 14 },
                'Dev. 22/21': { ocr: true, percent: true, value: -4 },
                'Dev. 22/19': { ocr: true, percent: true, value: 4 },
            },
            {
                date: '2022-04-01',
                '2022': { ocr: true, percent: true, value: 12 },
                'Dev. 22/21': { ocr: true, percent: true, value: -3 },
                'Dev. 22/19': { ocr: true, percent: true, value: 4 },
            },
            {
                date: '2022-05-01',
                '2022': { ocr: true, percent: true, value: 10 },
                'Dev. 22/21': { ocr: true, percent: true, value: -2 },
                'Dev. 22/19': { ocr: true, percent: true, value: 4 },
            },
            {
                date: '2022-06-01',
                '2022': { ocr: true, percent: true, value: 11 },
                'Dev. 22/21': { ocr: true, percent: true, value: -2 },
                'Dev. 22/19': { ocr: true, percent: true, value: 4 },
            },
            {
                date: '2022-07-01',
                '2022': { ocr: true, percent: true, value: 13 },
                'Dev. 22/21': { ocr: true, percent: true, value: 1 },
                'Dev. 22/19': { ocr: true, percent: true, value: 4 },
            },
        ],
    },
};
